import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
export class FormModel extends CoreModel {
/**
 * Array with questions
 */
questions?: any[];
/**
 * Maximum form columns
 */
maxColumns?: number;
/**
 * Questions from the template to be added to the questions sent from the user
 */
commonQuestions?: any[];
/**
 * Name of form group with questions
 */
key?: string;
/**
 * Data to be patched into form
 */
payload?: any;
/**
 * Form submit button
 */
submitButton?: ButtonModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FormModel_tsickle_Closure_declarations() {
/**
 * Array with questions
 * @type {?}
 */
FormModel.prototype.questions;
/**
 * Maximum form columns
 * @type {?}
 */
FormModel.prototype.maxColumns;
/**
 * Questions from the template to be added to the questions sent from the user
 * @type {?}
 */
FormModel.prototype.commonQuestions;
/**
 * Name of form group with questions
 * @type {?}
 */
FormModel.prototype.key;
/**
 * Data to be patched into form
 * @type {?}
 */
FormModel.prototype.payload;
/**
 * Form submit button
 * @type {?}
 */
FormModel.prototype.submitButton;
}

